import { Card, Form } from 'react-bootstrap';
import { getDateAfterDays, getDateYYYYMMDD } from '../../../../sitel/commons/utilities/dates';
import { PageCardWrapper } from '../../../../sitel/demon/ui/atoms';
import { FieldValidationErrorMsg, RequiredAsterisk } from '../../../../sitel/demon/ui/atoms/form';

export default function PreEmployeeHeader({ register, errors }) {
  return (
    <PageCardWrapper title='This information is required for reporting and to help identify any previous MedStar Health accounts.'>
      <Card.Body>
        <Card.Title>Hiring Details</Card.Title>
        <Card.Text>Please fill this information to the best of your knowledge:</Card.Text>
        <div className='row'>
          <div className='form-group col-lg-4'>
            <label htmlFor='startDate'>Start date</label>
            <RequiredAsterisk />
            <Form.Control type='date' id='startDate' min={getDateYYYYMMDD(getDateAfterDays())} {...register('startDate')} />
            <FieldValidationErrorMsg field='startDate' errors={errors} />
          </div>
          <div className='form-group col-lg-4'>
            <label htmlFor='hiringManagerName'>Hiring manager name</label>
            <RequiredAsterisk />
            <input type='text' className='form-control' id='hiringManagerName' placeholder='first name + last name' {...register('hiringManagerName')} />
            <FieldValidationErrorMsg field='hiringManagerName' errors={errors} />
          </div>
          <div className='form-group col-lg-4'>
            <label htmlFor='hiringManagerEmail'>Hiring manager email</label>
            <RequiredAsterisk />
            <input type='email' className='form-control' id='hiringManagerEmail' placeholder='@medstar.net @gunet.georgetown.edu' {...register('hiringManagerEmail')} />
            <FieldValidationErrorMsg field='hiringManagerEmail' errors={errors} />
          </div>
        </div>
      </Card.Body>
    </PageCardWrapper>
  );
}
